const AppColor = Object.freeze({
  mainColor: "#59d5b2",
  mainLight: "#e0f8f1",
  mainBlue: "#5BD2FF",
  blue: "#2866bf",
  blueDark: "#1f417c",
  blueLighten: "#3893C8",
  yellow: "#ffd200",
  green: "#08b996",
  greenLighten: "#36c98e",
  greyLighten: "#f1f1f1",
  greyLighten2: "#dcdcdc",
  greyLighten3: "#e9e9e9",
  greyLighten4: "#e3e3e3",
  greyLighten5: "#f9f9f9",
  greyLighten6: "#eeeeee",
  grey: "#cccccc",
  yellowLighten: "#fff7d4",
  orange: "#F08828",
  turquoise: "#5bd2ff",
  white: "#ffffff",
  wine: "#C4C4C4",
  black: "#000000",
  greyDarker: "#3D3D3D",
  greyDark: "#555555",
  redDarker: "#93291E",
  red: "#fe6359",
  pink: "#f3959b",
  violet: "#845086",
  bgGrey: "#ECECEC",
  selectBox: "#399DB1",
  purpleLighten: "#C13AC7",
  darkPurple: "#3D2C3E",
  darkBlue: "#28465e",
  descriptionBg: '#F1EEEC',
  availability: "#59d5b2",
  notificationBg : "#BA8EBC",
  cinnabar: '#CB6040',
  yellowGradientToRight: "linear-gradient(to right, #f7971e , #ffd200)",
  yellowGradientToLeft: "linear-gradient(to left, #f7971e , #ffd200)",
  yellowGradientToBottom: "linear-gradient(to bottom, #f7971e , #ffd200)",
  yellowGradientToTop: "linear-gradient(to top, #f7971e , #ffd200)",
  greyGradientToRight: "linear-gradient(to right, #3D3D3D , #555555)",
  greyGradientToLeft: "linear-gradient(to left, #3D3D3D , #555555)",
  greyGradientToBottom: "linear-gradient(to bottom, #3D3D3D , #555555)",
  greyGradientToTop: "linear-gradient(to top, #3D3D3D , #555555)",
  redGradientToRight: "linear-gradient(to right, #93291E , #E52F00)",
  redGradientToLeft: "linear-gradient(to left, #93291E , #E52F00)",
  redGradientToBottom: "linear-gradient(to bottom, #93291E , #E52F00)",
  redGradientToTop: "linear-gradient(to top, #93291E , #E52F00)",
  crystalGradientToTop: "linear-gradient(to top, #59d5b2 , #36C98E)",
  crystalGradientToRight: "linear-gradient(to right, #59d5b2 , #36C98E)",
  crystalGradientToBottom: "linear-gradient(to bottom, #59d5b2 , #36C98E)",
  crystalGradientToLeft: "linear-gradient(to left, #59d5b2   , #36C98E)",
  blueGradientToTop: "linear-gradient(to top, #1F417C, #2866BF)",
  blueGradientToLeft: "linear-gradient(to left, #1F417C, #2866BF)",
  blueGradientToBottom: "linear-gradient(to bottom, #1F417C, #2866BF)",
  blueGradientToRight: "linear-gradient(to right, #1F417C, #2866BF)",
  wineGradientToLeft: "linear-gradient(to right, #4d0322, #8a2851)",
  orangeGradientToLeft: "linear-gradient(to right, #ec9f05, #ff4e00)",
});

export default AppColor;
